import * as React from "react";

const ExclamationInCircleIcon = ({
  brandingColor = "#C60000",
}: {
  brandingColor?: string;
}) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM10 6V11M10 14V14.1"
      stroke={brandingColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ExclamationInCircleIcon;
